import * as $ from './unit'
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux'
import * as activityAction from '../actions/activityAction';
import * as baseAction from '../actions/baseAction';
import * as commonAction from '../actions/commonAction';
import * as gameAction from '../actions/gameAction';
import * as lotteryAction from '../actions/lotteryAction';
import * as pushAction from '../actions/pushAction';
import * as reportAction from '../actions/reportAction';
import * as userAction from '../actions/userAction';
import * as dashAction from '../actions/dashBoardAction'

import * as reportService from '../services/reportService'
import * as lotteryService from '../services/lotteryService.jsx'
require('./jquery-1.8.3.min.js');

export function initContext(){
	window.$ = $;
	window.React = React;
	window.ReactDOM = ReactDOM;
	window.bindActionCreators = bindActionCreators;
	window.Component = Component;
	window.baseAction = baseAction;
	window.commonAction = commonAction;
	window.gameAction = gameAction;
	window.lotteryAction = lotteryAction;
	window.pushAction = pushAction;
	window.reportAction = reportAction;
	window.userAction = userAction;
	window.activityAction = activityAction;
	window.dashAction = dashAction;
	
	window.reportService = reportService;
	window.lotteryService = lotteryService;
}
